<template>
  <div class="main">
    <div class="box1">
      <div class="box">
        <img src="@/assets/tabs/Q&A.png">
        <div>
          <div class="title">如何解决传统供应链面临的问题？</div>
          <p class="text">通过沃时数字化包装管理创新平台集合海量包装数据驱动供应链自动化、全过程可视化，帮助企业保证包装供应和包装总成本降低</p>
        </div>
      </div>

    </div>
    <div class="box2">
      <div class="bg"></div>
      <div class="box">
        <div class="textBox">
          <div class="title" @click="active = 1" :style="{color:active==1?'#1E284D':'#A4A4A4'}">过程控制（MES+TMS）</div>
          <div class="title" @click="active = 2" :style="{color:active==2?'#1E284D':'#A4A4A4'}">结果控制（QMS）</div>
          <div class="text" v-if="active == 1">
            自主研发沃时云制造（MES系统）和沃时货运助手（TMS系统），打通了企业与生产工厂间的信息孤岛，过程数据更实时化，同时掌握生产、库存和物流信息，提升企业间供需要求反应速度。以确保在供应链风险加剧的情况下，仍能满足企业对于供应保障的需求。
          </div>
          <div class="text" v-if="active == 2">
            自研的包装质量管理系统（QMS系统），实时掌握品质动态，提前了解包装状况，实时调整运营计划，调度生产更便捷，将原来的事后管理转变为现在的事先管理，既满足生产条件又确保包装物料品质一致性。
          </div>
          <div class="control">
            <img class="img" @click="active = active == 1 ? 2 : 1" src="@/assets/tabs/left.png">
            <img class="img" @click="active = active == 1 ? 2 : 1" src="@/assets/tabs/right.png">
          </div>
        </div>
        <div class="exhibit">
          <img v-if="active == 1" class="img" src="@/assets/tabs/exhibit.png">
          <img v-if="active == 2" class="img" src="@/assets/tabs/exhibit2.png">
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="box">
        <div class="title">汇聚800+各类包装工厂的在线供应网络</div>
        <div class="contentBox">
          <img class="map" src="@/assets/tabs/map2.png">
          <div class="rightBox">
            <div class="text">突破资源束缚，800+的各类包装和原材料工厂，使上下游企业在平台匹配更合适的交易，降低仓储、物流、损耗、原材料成本，呈现更加开放、包容的包装产业业态大融合</div>
            <div class="countBox">
              <div>
                <div class="count">800+</div>
                <div class="text">包装工厂</div>
              </div>
              <div>
                <div class="count">20+</div>
                <div class="text">遍布省份</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box4">
      <div class="box">
        <div class="leftBox">
          <div class="title">如何从根本上降低采购成本？</div>
          <div class="subtitle">TCO包装总成本降低</div>
          <div class="text">沃时包装助手（小程序）提升各部门人效，可减少每年100万+的管理费用。</div>
          <div class="text">数字化JIT和系统级API数据对接方案 库存数据交互，可降低40%+的库存成本，甚至真正零库存</div>
        </div>
        <div>
          <router-link class="btn" :to="{path: '/services', query: {anchorPoint: 'cost' }}">查看更多</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.timeChange()
  },
  methods: {
    timeChange() {
      setTimeout(() => {
        this.active = this.active == 1 ? 2 : 1
        this.timeChange()
      }, 3500)
    },
  }
}
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.box1 {
  width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(180deg, #f7f8fb 0%, rgba(247, 248, 251, 0) 100%);
  .box {
    display: flex;
    align-items: center;
    width: 1200px;

    img {
      width: 781px;
      height: 503px;
    }
    .title {
      color: #3359cc;
      font-size: 26px;
    }
    .text {
      margin-top: 20px;
      font-size: 14px;
      color: #666666;
    }
  }
}
.box2 {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 162px;
  position: relative;
  .bg {
    position: absolute;
    top: 0;
    right: 0;
    background-image: url("../../../assets/tabs/map.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 1185px;
    height: 1173px;
    z-index: -2;
  }
  .box {
    display: flex;
    width: 1200px;
    .textBox {
      width: 499px;
      .title {
        font-size: 36px;
        color: #a4a4a4;
        cursor: pointer;
      }
      .text {
        margin-top: 70px;
        color: #666666;
        line-height: 42px;
        height: 180px;
      }
      .control {
        .img {
          width: 34px;
          height: 34px;
          margin: 41px 13px 0 0;
          border-radius: 50%;
        }
        .img:hover {
          box-shadow: 0px 0px 11px #c1c1c1;
        }
      }
    }
    .exhibit {
      z-index: -1;
      .img {
        width: 702px;
        height: 544px;
      }
    }
  }
}
.box3 {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 162px;
  .box {
    display: flex;
    width: 1200px;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 36px;
      text-align: center;
      width: 407px;
      margin-bottom: 70px;
    }
    .contentBox {
      display: flex;
      justify-content: space-between;
      flex-direction: initial;
      align-items: center;
      .map {
        width: 664px;
        height: 653px;
      }
      .rightBox {
        width: 471px;
        .text {
          font-size: 14px;
          color: #666666;
          line-height: 42px;
        }
        .countBox {
          display: flex;

          .count {
            font-size: 36px;
            margin-right: 75px;
            font-weight: 800;
            color: #333333;
            line-height: 42px;
          }
          .text {
            font-weight: 500;
            color: #333333;
            line-height: 19px;
          }
        }
      }
    }
  }
}
.box4 {
  width: 100%;
  height: 305px;
  background-image: url("../../../assets/tabs/footBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  .box {
    color: #fff;
    width: 1000px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .leftBox {
      .title {
        font-size: 35px;
        font-weight: 500;
        line-height: 41px;
      }
      .subtitle {
        font-size: 24px;
        font-weight: 500;
        line-height: 28px;
        margin: 26px 0 12px 0;
      }
      .text {
        font-size: 14px;
        line-height: 30px;
      }
    }
    .btn {
      border-radius: 28px;
      padding: 10px 25px;
      background-color: #3359cc;
      border-color: #3359cc;
      color: #fff;
    }
    .btn:hover {
      background-color: #486ad0;
      border-color: #486ad0;
    }
  }
}
</style>